.fj{border:1px solid #ddd;}